export const handleTelLink = (phoneNumber: string, event: React.MouseEvent) => {
  // Always prevent default and use window.location.href for better compatibility
  event.preventDefault();

  // Clean the phone number
  const cleanPhoneNumber = phoneNumber.replace(/[^0-9+]/g, '');

  // Handle iOS WebView case specifically
  if (isIOSWebView()) {
    // Use IS24 deeplink scheme for iOS WebView
    window.location.href = `is24://externalLink?url=tel:${cleanPhoneNumber}`;
    return;
  }

  // For other browsers
  try {
    window.open(`tel:${cleanPhoneNumber}`, '_self');
  } catch (error) {
    window.location.href = `tel:${cleanPhoneNumber}`;
  }
};

export const createTelLinkHandler = (phoneNumber: string) => {
  return (event: React.MouseEvent) => {
    handleTelLink(phoneNumber, event);
  };
};

export const cleanPhoneNumber = (phoneNumber: string): string => {
  return phoneNumber.replace(/[^0-9+]/g, '');
};

export const isIOSWebView = (): boolean => {
  const userAgent = navigator.userAgent;
  return /iPhone|iPad|iPod/i.test(userAgent) && !/Safari/i.test(userAgent);
};

export const isIOS = (): boolean => {
  const userAgent = navigator.userAgent;
  return /iPhone|iPad|iPod/i.test(userAgent);
};
